import React, { useState } from 'react';
import { DASHBOARD_SIDEBAR_BOTTOM_LINKS, DASHBOARD_SIDEBAR_LINKS } from '../../lib/consts/navigation';
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import logo from '../../images/logo.png'
import logoSmall from '../../images/logo-small.png'
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { HiOutlineLogout } from 'react-icons/hi';



const linkClasses = 'flex items-center gap-2 font-light px-2 py-2 hover:bg-neutral-700 hover:no-underline active:bg-neutral-600 rounded-sm text-base';


function SiderbarLink({ item }) {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const handleNav = (e) => {
        e.preventDefault();
        if (typeof window.guardedNavigate === 'function') {
            window.guardedNavigate(item.path);
        } else {
            navigate(item.path);
        }
    };
    return (
        <a
            href={item.path}
            onClick={handleNav}
            className={classNames(pathname === item.path || pathname.startsWith('/' + item.key) ? 'text-amber-600 font-medium' : 'text-neutral-500', linkClasses)}
        >
            <span className='text-xl mr-4'>{item.icon}</span>
            <span>{item.label}</span>
        </a>
    );
}

function Sidebar() {
  const [expanded, setExpanded] = useState(true);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (

    <div className={classNames('bg-neutral-900 pt-6 p-3 flex flex-col text-white duration-700 overflow-hidden', expanded ? 'w-60' : 'w-16')}>
        <div className={classNames('hover:bg-neutral-700 px-3 py-2 rounded-sm cursor-pointer self-end')} onClick={() => toggleExpand()}>
            {expanded ? <IoIosArrowBack /> : <IoIosArrowForward />}
        </div>
        <div className='flex items-center justify-center gap-2 px-1 py-3 min-h-28'>

            {expanded ? <img className='w-40' alt='Minerva Analytics' src={logo} /> : <img className='w-16' alt='Minerva Analytics' src={logoSmall} />}

        </div>
        <div className={classNames('flex-1 py-8 flex flex-col gap-2 ')}>
            <div className="icons-container" style={{ width: expanded ? 'auto' : '50px' }}> {/* Fixed width for the icons container */}
              {DASHBOARD_SIDEBAR_LINKS.map((item) => (
                  <SiderbarLink key={item.key} item={item}  />
              ))}
            </div>
        </div>
        <div className='flex flex-col gap-0.5 pt-2 border-t border-neutral-700'>
            {DASHBOARD_SIDEBAR_BOTTOM_LINKS.map(item => (
               <SiderbarLink key={item.key} item={item} /> 
            ))}
        </div>
    </div>
  );
}

export default Sidebar;


